import { render, staticRenderFns } from "./cp_news_info.vue?vue&type=template&id=5cc49afc&scoped=true"
import script from "./cp_news_info.vue?vue&type=script&lang=js"
export * from "./cp_news_info.vue?vue&type=script&lang=js"
import style0 from "./cp_news_info.vue?vue&type=style&index=0&id=5cc49afc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc49afc",
  null
  
)

export default component.exports